module.exports = __webpack_public_path__ + "static/media/status-in-export.9cf37d9f.svg";